import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
export function appendModuleKeyPrefix(subModuleObject = {}, prefix) {
  /*
    为了后续开发便于阅读代码，显示标注以下参数字面量
    prefix = 'sr'
    const subModuleObject = {
      NAME: 'common',
      GETTER: {
        GET_ORIGIN_METADATA: 'common/getOriginMetadata',
        GET_CUSTOM_METADATA: 'common/getCustomMetadata',
        GET_ENTITY_ID_BY_ENTITY_SET: 'common/getEntityIdByEntitySet'
      },
      MUTATION: {
        UPDATE_ENTITY: 'common/updateEntity',
        CLEAR_ENTITY: 'common/clearEntity',
        UPDATE_CUSTOM_ENTITY: 'common/updateCustomEntity'
      },
      ACTION: {
        FETCH_ENTITY: 'common/fetchEntity'
      }
    }
       return ret = {
      GET_ORIGIN_METADATA: 'sr/common/getOriginMetadata',
      GET_CUSTOM_METADATA: 'sr/common/getCustomMetadata',
      GET_ENTITY_ID_BY_ENTITY_SET: 'sr/common/getEntityIdByEntitySet',
      UPDATE_ENTITY: 'sr/common/updateEntity',
      CLEAR_ENTITY: 'sr/common/clearEntity',
      UPDATE_CUSTOM_ENTITY: 'sr/common/updateCustomEntity',
      FETCH_ENTITY: 'sr/common/fetchEntity',
    }
  */
  const ret = {};
  const keywords = ['GETTER', 'MUTATION', 'ACTION'];
  keywords.forEach(keyword => {
    ret[keyword] = {};
    if (subModuleObject[keyword]) {
      Object.keys(subModuleObject[keyword]).forEach(key => {
        ret[keyword][key] = `${prefix}/${subModuleObject[keyword][key]}`;
      });
    }
  });
  return ret;
}